"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Checkbox = _interopRequireDefault(require("../../Checkbox/Checkbox"));

var _util = require("../../../util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// otherProps are for Checkbox
var RowSelection = function RowSelection(_ref) {
  var row = _ref.row,
      className = _ref.className,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["row", "className"]);
  var original = row.original,
      getToggleRowSelectedProps = row.getToggleRowSelectedProps;
  return (0, _jsxRuntime.jsx)(_Checkbox["default"], _objectSpread(_objectSpread(_objectSpread({}, getToggleRowSelectedProps()), otherProps), {}, {
    id: original.id,
    className: (0, _clsx["default"])('grui block', className),
    disabled: !!(original !== null && original !== void 0 && original.isDisabled)
  }));
};

RowSelection.propTypes = {
  className: _propTypes.string,
  row: (0, _propTypes.shape)({
    id: _propTypes.string,
    isDisabled: _propTypes.bool,
    getToggleRowSelectedProps: _propTypes.func
  })
};
RowSelection.defaultProps = {
  className: undefined,
  row: {
    id: '',
    isDisabled: false,
    getToggleRowSelectedProps: function getToggleRowSelectedProps() {}
  }
}; // Column config for checkbox

RowSelection.column = {
  Header: '',
  accessor: 'selection',
  Cell: RowSelection,
  width: (0, _util.rem)(48),
  disableSortBy: true
};
var _default = RowSelection;
exports["default"] = _default;
//# sourceMappingURL=RowSelection.js.map